var React = require('react');

function MoreVertical (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M48 52C50.2091 52 52 50.2091 52 48C52 45.7909 50.2091 44 48 44C45.7909 44 44 45.7909 44 48C44 50.2091 45.7909 52 48 52Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M48 24C50.2091 24 52 22.2091 52 20C52 17.7909 50.2091 16 48 16C45.7909 16 44 17.7909 44 20C44 22.2091 45.7909 24 48 24Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M48 80C50.2091 80 52 78.2091 52 76C52 73.7909 50.2091 72 48 72C45.7909 72 44 73.7909 44 76C44 78.2091 45.7909 80 48 80Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

MoreVertical.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = MoreVertical;

MoreVertical.default = MoreVertical;
